<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">
          <form @submit.prevent="form.onSubmit" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div class="form-group" :class="{'has-error': form.errors.has('serviceDate') }">
              <label class="control-label">Call Date</label>
              <date-picker v-model="form.data.serviceDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('serviceDate')" v-text="form.errors.get('serviceDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('contractId') }">
              <label class="control-label">Contract</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.contractId">
                  <option></option>
                  <option v-for="item in contracts" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('contractId')" v-text="form.errors.get('contractId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('inspectionId') }">
              <label class="control-label">Request Id <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="inspectionId" v-model="form.data.inspectionId">
              <span class="help-block" v-if="form.errors.has('inspectionId')" v-text="form.errors.get('inspectionId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('name') }">
              <label class="control-label">Name <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="name" v-model="form.data.name">
              <span class="help-block" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('address') }">
              <label class="control-label">Address</label>
              <input type="text" class="form-control" id="address" v-model="form.data.address">
              <span class="help-block" v-if="form.errors.has('address')" v-text="form.errors.get('address')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('city') }">
              <label class="control-label">City</label>
              <input type="text" class="form-control" id="city" v-model="form.data.city">
              <span class="help-block" v-if="form.errors.has('city')" v-text="form.errors.get('city')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('stateId') }">
              <label class="control-label">State</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.stateId">
                  <option></option>
                  <option v-for="item in states" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('stateId')" v-text="form.errors.get('stateId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('zip') }">
              <label class="control-label">Zip</label>
              <input type="text" class="form-control" id="zip" v-model="form.data.zip">
              <span class="help-block" v-if="form.errors.has('zip')" v-text="form.errors.get('zip')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('phoneDay') }">
              <label class="control-label">Phone (Day) <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="phoneDay" v-model="form.data.phoneDay">
              <span class="help-block" v-if="form.errors.has('phoneDay')" v-text="form.errors.get('phoneDay')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('phoneNight') }">
              <label class="control-label">Phone (Night) <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="phoneNight" v-model="form.data.phoneNight">
              <span class="help-block" v-if="form.errors.has('phoneNight')" v-text="form.errors.get('phoneNight')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('assignedToInspector') }">
              <label>
                <input type="checkbox" id="assignedToInspector" v-model="form.data.assignedToInspector"> Assigned to inspector
               <span class="optional">(optional)</span></label>
              <span class="help-block" v-if="form.errors.has('assignedToInspector')" v-text="form.errors.get('assignedToInspector')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('inspectionDate') }">
              <label class="control-label">Inspection Date <span class="optional">(optional)</span></label>
              <date-picker v-model="form.data.inspectionDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('inspectionDate')" v-text="form.errors.get('inspectionDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('status') }">
              <label class="control-label">Work Status</label>
              <select class="form-control" v-model="form.data.status">
                <option v-for="item in completedStatus">{{item}}</option>
              </select>
              <span class="help-block" v-if="form.errors.has('status')" v-text="form.errors.get('status')"></span>
            </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import DatePicker from '@/components/date-picker';

  export default {
    name: 'service-request-form',

    props: ['form'],

    components: {
      LoadingButton,
      DatePicker,
    },

    computed: {
      contracts() {
        return this.$store.getters.contracts;
      },
      municipalities() {
        return this.$store.getters.municipalities;
      },
      states() {
        return this.$store.getters.states;
      },
      completedStatus() {
        return this.$store.getters.completedStatus;
      },
      zones() {
        return this.$store.getters.zones;
      },
      applicators() {
        return this.$store.getters.applicators;
      },

    },

  }

</script>